import { Injectable, inject } from '@angular/core';
import {BehaviorSubject, catchError, EMPTY, Observable, of} from 'rxjs';
import {API_URL} from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Customer, CustomerSearchAPI} from '../master-data/master-data.model';


@Injectable({
  providedIn: 'root'
})
export class CustomerService  {
  private http = inject(HttpClient);


  private selectedCustomer = new BehaviorSubject<Customer>(null);

  getCustomersByUuid(uuid: string): Observable<Customer> {
    return this.http
      .get<Customer>(API_URL + "customer/by-uuid/" + uuid, {})
      .pipe(catchError(() => of(EMPTY))) as Observable<Customer>;
  }

  getCostumersBySearch(search: string, pageNumber = 0, pageSize = 10): Observable<CustomerSearchAPI>{
    return this.http.get<CustomerSearchAPI>(API_URL + 'customer/paged',{
      params: new HttpParams()
        .set('page', pageNumber.toString())
        .set('size', pageSize.toString())
        .set('search', search)
    }).pipe(
      catchError(() => of(EMPTY))
    ) as Observable<CustomerSearchAPI>;
  }



}
